export default {
  setItem(key, value) {
    return sessionStorage.setItem(key, JSON.stringify(value));
  },

  getItem(key) {
    return sessionStorage.getItem(key) !== undefined
      ? JSON.parse(sessionStorage.getItem(key))
      : {};
  },

  deleteItem(key) {
    return sessionStorage.removeItem(key);
  },
};
